// extracted by mini-css-extract-plugin
module.exports = {"questionContent":"fLE_iyzU","collapse":"__2FGWoi1O","arrow":"__1f7XtEF1","content":"mAVYxUAG","more":"NHXGhKdo","link":"yAEq6qbM","icon":"TfC7ZpxI","text":"k_IopR9r"};